import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import { useTranslation } from '../../../translations';

export const SurveyPreviewLink: React.FC<{ surveyId: string }> = ({
  surveyId,
}) => {
  const { t, tk } = useTranslation('administrationLng');
  const nav = useNavigation();

  const handleClick = () => {
    nav.previewSurvey(surveyId, false);
  };

  return (
    <OverlayTrigger overlay={<Tooltip>{t(tk.survey.preview)}</Tooltip>}>
      <Button
        className="p-0"
        onClick={e => {
          e.stopPropagation();
          handleClick();
        }}
        variant="btn-info"
      >
        <Icon.Eye className="icon-blue" size={16} />
      </Button>
    </OverlayTrigger>
  );
};
